import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";
import axios from "axios";

export class AccountService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getAccounts(page, size, fundId, filterGroupName, filterFullName, filterNationalCode, filterAccountCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundId}/deposit-accounts`,
                {
                    page,
                    size,
                    "full-name": filterFullName,
                    "national-code": filterNationalCode,
                    "group-name": filterGroupName,
                    "deposit-account-number": filterAccountCode
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewAccount(fundID, id, guardian, balance, accountCode, date, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/members/${id}/deposit-accounts`,
                {
                    "number": accountCode,
                    "initialBalance": balance,
                    "enabled": enabled,
                    "openedAt": convertPersianDateToUniversalDate(date),
                    "guardianId": guardian
                }
            ).then(resolve).catch(reject)
        })
    }

    getAccountDetail(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/deposit-accounts/${id}`
            ).then(resolve).catch(reject)
        })
    }

    getAccountStatusInfo(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/deposit-accounts/${id}/status-details`
            ).then(resolve).catch(reject)
        })
    }

    updateAccountDetail(fundID, accountId, number, openedAt, enabled, guardianId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `/funds/${fundID}/deposit-accounts/${accountId}`,
                {
                    enabled,
                    number,
                    openedAt,
                    guardianId: guardianId && guardianId >= 0 ? guardianId : null
                }
            ).then(resolve).catch(reject)
        })
    }

    clearAccount(fundID, accountId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/deposit-accounts/${accountId}/clear`
            ).then(resolve).catch(reject)
        })
    }

    getDepositAccountReports(fundID, id, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.getFile(
                `funds/${fundID}/deposit-accounts/${id}/reports/${type}`
            ).then(resolve).catch(reject)
        })
    }

    getAccountLoansReports(fundID, accountId, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.getFile(
                `funds/${fundID}/deposit-accounts/${accountId}/loans/reports/${type}`
            ).then(resolve).catch(reject)
        })
    }

    getLoanInfo(fundID, accountId) {
        const loanOffers = this.httpClient.get(
            `funds/${fundID}/deposit-accounts/${accountId}/loans/offers`
        )

        const loanKinds = this.httpClient.get(
            `funds/${fundID}/deposit-accounts/${accountId}/loans/kinds/available`
        )

        return new Promise((resolve, reject) => {
            axios.all([loanOffers, loanKinds])
                .then(axios.spread((resLoanOffer, resLoanKind) => {

                    console.log("response ", resLoanOffer)

                    resolve({resLoanOffer, resLoanKind})
                })).catch(reject)
        })
    }

    uploadReceiptFile(fundID, id, file) {
        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).uploadFile(
                `${fundID}/monthly-deposits/${id}/monthly-deposit-receipts`,
                file
            ).then(resolve).catch(reject)
        })
    }

    getAccountCheckoutRequests(fundID, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/settlement-requests`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getAccountCheckoutDetail(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/settlement-requests/${id}`
            ).then(resolve).catch(reject)
        })
    }

    rejectCheckoutRequest(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/settlement-requests/${id}/reject`
            ).then(resolve).catch(reject)
        })
    }

    acceptCheckoutRequest(fundID, id) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/settlement-requests/${id}/accept`
            ).then(resolve).catch(reject)
        })
    }
}